import { apiSlice } from '@/shared/api/apiSlice'
import { ServerResponse } from '@/shared/types/common'

export interface TipsResponse {
	QUERY: string
	TIPS: Tips[]
	CATEGORIES: Categories[]
	ITEMS: Product[]
	HISTORY: string[]
	REDIRECT_URL: string
}

export interface Tips {
	request: string
	show_tips: string
	count: number
	redirect_url: string
}

export interface Categories {
	id: number
	name: string
}

export interface Product {
	name: string
	alias: string
	code: string
	category_id: number
	article: string
	priority: number
	price: string
	old_price: string
	image: string
}

export const searchApi = apiSlice.injectEndpoints({
	endpoints: build => ({
		getTips: build.query<TipsResponse, { value: string }>({
			query: ({ value }) => ({
				url: `/nbc/tip`,
				method: 'GET',
				credentials: 'include',
				params: {
					search: value
				}
			}),
			transformResponse: (res: ServerResponse<TipsResponse>) => {
				return res.data
			}
		}),
		getPrompt: build.query<string[], void>({
			query: () => ({
				headers: {
					'Content-Type': 'application/json'
				},
				url: '/nbc/tip/prompt',
				method: 'POST',
				credentials: 'include',
				body: {
					url: 'https://www.iport.ru'
				}
			}),
			transformResponse: (res: ServerResponse<{ PROMPTS: string[] }>) => {
				return res.data?.PROMPTS || []
			},
			// Кэшируем промпты на 10 минут - они редко меняются
			keepUnusedDataFor: 600
		})
	})
})

export const { useLazyGetTipsQuery, useLazyGetPromptQuery, useGetPromptQuery, useGetTipsQuery } = searchApi
